import {useMutation, useQuery, useQueryClient} from "@tanstack/react-query";
import {useAxiosPrivate} from "../useAxiosPrivate";

export default function usePriceQueries() {
    const axiosPrivate = useAxiosPrivate();
    const queryClient = useQueryClient();

    // QUERIES ------------------------------------------------------

    const priceBusinessQuery = useQuery({
        queryFn: () =>
            axiosPrivate
                .get("price/get_for_business/")
                .then(r => r.data),
        queryKey: ["price", "get_for_business"],
    });

    const usePriceServiceQuery = (id) =>
        useQuery({
            queryKey: ["price", id],
            queryFn: ({ queryKey }) => {
                const [, serviceId] = queryKey;
                return axiosPrivate
                    .get(`price/get_for_service/?service=${serviceId}`)
                    .then((r) => r.data);
            },
            enabled: !!id, // prevents running until id exists
        });


    const usePriceColleagueQuery = (id) =>
        useQuery({
            queryKey: ["price", id],
            queryFn: ({ queryKey }) => {
                const [, colleagueId] = queryKey;
                return axiosPrivate
                    .get(`price/get_for_colleague?colleague=${colleagueId}`)
                    .then((r) => r.data);
            },
            enabled: !!id, // prevents running until id exists
        });


    const usePriceQuery = (id) =>
        useQuery({
            queryKey: ["price", id],
            queryFn: ({ queryKey }) => {
                const [, priceId] = queryKey;
                return axiosPrivate
                    .get(`price/${priceId}/`)
                    .then((r) => r.data);
            },
            enabled: !!id, // prevents running until id exists
        });

    // MUTATIONS ------------------------------------------------------

    const createPriceMutation = useMutation({
            mutationFn: (data) => axiosPrivate.post(`price/`, data).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["price"]);
            },
        });

    const updatePriceMutation = useMutation({
            mutationFn: ({id, data}) => axiosPrivate.patch(`price/${id}/`, data).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["price"]);
            },
        });

    const deletePriceMutation = useMutation({
            mutationFn: id => axiosPrivate.delete(`price/${id}/`).then(r => r.data),
            onSuccess: (...args) => {
                queryClient.invalidateQueries(["price"]);
            },
        });



    return {
        priceBusinessQuery,
        usePriceServiceQuery,
        usePriceColleagueQuery,
        usePriceQuery,
        createPriceMutation,
        updatePriceMutation,
        deletePriceMutation,
    };
}
